import { DeleteModalComponent } from './../../shared/delete-modal/delete-modal.component';
import { Injectable, EventEmitter } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";

@Injectable()
export class DeleteModalService {
  constructor(public dialog: MatDialog) {}
  public closed: EventEmitter<any> = new EventEmitter();

  openModal(data) {
    this.dialog
      .open(DeleteModalComponent, {
        minWidth: "50vw",
        minHeight: "20vh",
        disableClose: true,
        data: data
      })
      .afterClosed().subscribe(data=>{
        this.closed.emit(data);
      });
  }
}
